<template>
  <div class="admin-departmentlist">
    <admin-template
      :endpointUrl="endpointUrl"
      :title="title"
      :tableSort="{prop: 'name', order: 'ascending'}"
      :visibleTenantsSelect="false"
    >
      <template slot="table-columns">
        <el-table-column type="selection" width="55" :selectable="selectableRow"></el-table-column>
        <el-table-column prop="name" label="所属名" sortable>
          <template slot-scope="scope">{{ scope.row.name}}</template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              icon="el-icon-edit"
              size="small"
              @click="onClickEditButton(scope.row.uuid)"
            >所属名の変更</el-button>
            <el-button
              size="small"
              @click="onClickAssignUser(scope.row.uuid)"
            >
              <i class="fab fa-openid"></i>
              ユーザの割当
            </el-button>
          </template>
        </el-table-column>
      </template>
    </admin-template>

    <admin-dialog
      :endpointUrl="endpointUrl"
      :endpointBulkDeleteUrl="endpointBulkDeleteUrl"
      :title="title"
      :form="form"
      :selection="selection"
    >
      <template slot="dialogFormItem">
        <el-form-item label="所属名" prop="name">
          <el-input v-model="form.data.name" auto-complete="off" :autofocus="true"></el-input>
        </el-form-item>
      </template>
    </admin-dialog>

    <div class="user-assign">
      <el-dialog
        class="user-assign-dialog"
        title="ユーザの割当"
        :visible.sync="userAssignDialog.visible"
        :close-on-click-modal="false"
        align="left"
      >
        <el-select v-model="userAssignDialog.assigned_user" multiple placeholder="Select">
          <el-option
            v-for="user in userAssignDialog.no_assigned_user"
            :key="user.uuid"
            :label="user.username"
            :value="user.uuid"
          ></el-option>
        </el-select>
        <el-alert
          v-if="userAssignDialog.isAlert"
          :title="userAssignDialog.errorMessage"
          type="error"
          show-icon
          :closable="false"
        ></el-alert>
        <span slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            @click="handleUserAssign"
            :loading="userAssignDialog.loading"
          >OK</el-button>
          <el-button @click="UserAssignCancel">キャンセル</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import AdminTemplate from "@/components/admin/Template";
import AdminDialog from "@/components/admin/Dialog";
import { AdminEventBus } from "@/components/admin/EventBus";
import axios from "axios";
import { executeRequest } from "@/components/requests";

export default {
  components: {
    AdminTemplate,
    AdminDialog
  },

  data() {
    const endpointUrl = "/api/accounts/admin/departments/";
    const endpointBulkDeleteUrl = "/api/accounts/admin/departments-bulk/";
    const UserListUrl = "/api/accounts/admin/departments-user/";
    const title = "ユーザ内所属管理";
    const initialFormData = {
      uuid: 0,
      name: "",
      tenant: ""
    };
    const rule = {
      name: [
        {
          required: true,
          message: "所属名を入力してください",
          trigger: "blur"
        }
      ]
    };

    return {
      title,
      endpointUrl,
      endpointBulkDeleteUrl,
      UserListUrl,
      form: {
        ref: "adminDepartmentForm",
        labelWidth: "150px",
        data: Object.assign({}, initialFormData),
        rules: {
          create: rule,
          update: rule
        }
      },
      selection: [],

      userAssignDialog: {
        visible: false,
        form: {},
        no_assigned_user: [],
        assigned_user: [],
        loading: false,
        errorMessage: "",
        isAlert: false,
        department_id : 0,
      },

    };
  },
  created() {
    AdminEventBus.$on("init-form", () => {
      this.initForm();
    });
  },
  methods: {
    initForm() {
      this.form.data = Object.assign({}, this.initialFormData);
      axios
      .get("/api/accounts/profile/")
      .then(response => {
        this.form.data.tenant = response.data.tenant;
      })
      .catch(error => {
        console.log(error);
        if (error.response.status === 403) {
          this.form.username = error.response.data.username;
        } else {
          this.$router.push({ name: "login" });
        }
      });
    },
    onClickEditButton(uuid) {
      axios.get(`${this.endpointUrl}${uuid}/`).then(response => {
        this.form.data = response.data;
        AdminEventBus.$emit("click-edit");
      });
    },
    onClickAssignUser(uuid){
      this.userAssignDialog.no_assigned_user = []
      this.userAssignDialog.assigned_user = []
      axios.get(this.UserListUrl).then(response => {
        this.userAssignDialog.title = "管理するユーザの割当";
        this.userAssignDialog.no_assigned_user = response.data;
        this.userAssignDialog.department_id = uuid;

        this.userAssignDialog.no_assigned_user.forEach(user => {
          if (user.departments.includes(uuid)) {
            this.userAssignDialog.assigned_user.push(user.uuid)
          }
          this.userAssignDialog.visible = true;
        });
      });
    },

    selectableRow(row, index) {
      if (row.name === "admin") {
        return false;
      } else if (row.username === this.$store.getters.loginStatus.username) {
        return false;
      }
      return true;
    },
    executeApplicationRequest(request, dialog) {
      executeRequest(request, dialog)
        .then(response => {
          AdminEventBus.$emit("refresh");
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleUserAssign() {
      this.userAssignDialog.no_assigned_user.forEach(user => {
        if (this.userAssignDialog.assigned_user.includes(user.uuid)) {
          user.departments.push(this.userAssignDialog.department_id)
        }else{
          const newArray = user.departments.filter(n => n !== this.userAssignDialog.department_id);
          user.departments = newArray
        }
      });

      this.executeApplicationRequest(
        {
          method: "put",
          url: this.UserListUrl,
          data: this.userAssignDialog.no_assigned_user
        },
        this.userAssignDialog
      );
    },
    UserAssignCancel() {
      this.userAssignDialog.visible = false;
    },
  }
};
</script>

<style scoped>
.user-assign-dialog >>> .el-dialog {
  width: 600px;
}

.user-assign-dialog >>> .el-dialog__body {
  padding: 10px 20px;
}

.user-assign-dialog >>> .el-select {
  width: 100%;
}
.admin-departmentlist >>> .el-table__expanded-cell {
  padding: 0;
}

.admin-departmentlist >>> .el-table__row.expanded td {
  border-bottom: 0;
}

table.detail {
  margin: 8px 110px;
  border: 1px solid #ccc !important;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 12px;
  overflow: hidden;
}
.detail th,
.detail td {
  padding: 4px 16px;
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
}

.detail td:last-child,
.detail th:last-child {
  border-right: 0;
}
.detail thead th {
  background-color: #eee;
  font-weight: normal;
}
.detail tbody tr:last-child th,
.detail tbody tr:last-child td {
  border-bottom: none;
}

.detail .enabled,
.detail .period,
.detail .command {
  text-align: center;
}

.detail .enabled {
  width: 20px;
}
.detail .name {
  width: 200px;
}

.detail .period {
  width: 200px;
}

.detail .command {
  width: 200px;
}
</style>
